import { TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { IconButton, Menu, MenuItem, Checkbox, ListItemIcon, ListItemText } from '@material-ui/core';
import React, { useMemo, useState } from 'react';
import FilterListIcon from '@material-ui/icons/FilterList';
import PropTypes from 'prop-types';

const HeaderFilterCell = ({ column, children, rows, filters, onFiltersChange, ...restProps }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const values = useMemo(() => {
    if (column.name !== 'ClassRef') return [];

    // eslint-disable-next-line no-undef
    const set = new Set();
    rows.forEach((r) => {
      const v = r[column.name];
      if (v !== undefined && v !== null && v !== '') {
        set.add(v);
      }
    });
    return Array.from(set);
  }, [rows, column.name]);

  const currentFilter = filters.find((f) => f.columnName === column.name);

  const applyFilter = (value) => {
    const isActive = currentFilter && currentFilter.value === value;
    const next = filters.filter((f) => f.columnName !== column.name);

    if (value !== null && !isActive) {
      next.push({ columnName: column.name, value });
    }
    onFiltersChange(next);
    setAnchorEl(null);
  };

  if (column.name !== 'ClassRef') {
    return (
      <TableHeaderRow.Cell column={column} {...restProps}>
        {children}
      </TableHeaderRow.Cell>
    );
  }

  return (
    <TableHeaderRow.Cell column={column} {...restProps}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ flex: 1 }}>{children}</span>

        <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
          <FilterListIcon fontSize="small" color={currentFilter ? 'primary' : 'inherit'} />
        </IconButton>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
          <MenuItem onClick={() => applyFilter(null)}>
            <ListItemIcon>
              <Checkbox edge="start" checked={!currentFilter} tabIndex={-1} disableRipple />
            </ListItemIcon>
            <ListItemText primary="(All)" />
          </MenuItem>

          {values.map((v) => (
            <MenuItem key={v} onClick={() => applyFilter(v)}>
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={Boolean(currentFilter && currentFilter.value === v)}
                  tabIndex={-1}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText primary={String(v)} />
            </MenuItem>
          ))}
        </Menu>
      </div>
    </TableHeaderRow.Cell>
  );
};

export default HeaderFilterCell;

HeaderFilterCell.propTypes = {
  column: PropTypes.any,
  children: PropTypes.any,
  rows: PropTypes.any,
  filters: PropTypes.any,
  onFiltersChange: PropTypes.any
};
